define('collections/reseller_personals',['require','collections/base','models/reseller_personal'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/reseller_personal");

    return BaseCollection.extend({
        model: Model,
        url: 'reseller-managers.json'
    });
});

